import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import { animated } from "react-spring";
import Icon, { IconName } from "../../elements/Icon";
import Text from "../../elements/Text";

const ICON_SIZE = 18;
export const WIDTH_COLLAPSED = 54;
export const WIDTH_EXPANDED = 220;
const HOVER_COLOR = "hsl(0,0%,98.5%)";

const Base = styled(animated.div)<{ selected: boolean }>`
  height: ${WIDTH_COLLAPSED}px;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${select.color(["grey", 6])};
  transition: ${select.speed("fast")};
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;

  ${p =>
    p.selected
      ? css`
          color: ${select.color(["primary", 5])};
        `
      : css`
          &:hover {
            background-color: ${HOVER_COLOR};
            color: ${select.color(["grey", 9])};
            border-color: hsl(0, 0%, 96%);
          }
        `}
`;

const OpenItem = styled.div`
  padding: 4px;
  min-width: 18px;
  height: 18px;
  box-sizing: border-box;
  border-radius: 9px;
  background-color: ${select.color(["primary", 6])};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -12px;
  right: 3px;
  font-size: 10px;
  line-height: 1em;
  font-weight: bold;
  font-family: "Lato";
  border: 2px solid white;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  iconName: IconName;
  path: string;
  title: string;
  selected: boolean;
  onClick: (path: string) => void;
  openItems?: number;
};

function NavigationItem(
  {
    style,
    className,
    iconName,
    path,
    title,
    selected,
    onClick,
    openItems
  }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      onClick={() => onClick(path)}
      selected={selected}
    >
      <div style={{ position: "relative" }}>
        {openItems ? <OpenItem>{openItems}</OpenItem> : null}
        <Icon
          style={{
            margin: `0 ${(WIDTH_COLLAPSED - ICON_SIZE) / 2}px`,
            overflow: "visible",
            flexShrink: 0
          }}
          size={ICON_SIZE}
          name={iconName}
        />
      </div>
      <Text fs={-1} c="inherit" style={{ whiteSpace: "nowrap" }}>
        {title}
      </Text>
    </Base>
  );
}

export default React.forwardRef(NavigationItem);
